<button 
  type="button" 
  class="ai-generate-presentations-button tw-shadow-md" 
  [class.ai-generate-presentations-button-search-result]="isSearchResult" 
  aria-label="AI Generate Presentations" 
  (click)="onButtonClick()" 
  tabindex="0"
>
  <div class="ai-generate-presentations-button-content">
    <mat-icon svgIcon="ai-chatbot-square" class="ai-generate-presentations-button-icon"></mat-icon>
    <span class="ai-generate-presentations-button-text">Generate Presentations</span>
  </div>
</button>